import { LayoutContainer } from '../layout/LayoutContainer';

export const NotFoundPage = () => {
    return (
        <LayoutContainer>
            <div className="p-5 display-1 text-center">Not Found</div>
        </LayoutContainer>
    );
};
